import { __decorate } from "tslib";
import { customElement } from '@here/hds-base';
import { html, LitElement } from 'lit';
import { styles } from './hds-overlay.css.js';
/**
 * @slot default Content to be on top of the overlay
 */
let Overlay = class Overlay extends LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.shadowRoot.ownerDocument.body.classList.add('hds-noscroll');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.shadowRoot.ownerDocument.body.classList.remove('hds-noscroll');
    }
    render() {
        return html `
      <div class="wrapper">
        <slot></slot>
      </div>
    `;
    }
};
Overlay.styles = styles;
Overlay.shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
Overlay = __decorate([
    customElement('hds-overlay')
], Overlay);
export { Overlay };
//# sourceMappingURL=hds-overlay.js.map